import { Box, Typography } from "@mui/joy";
import { FileText } from "lucide-react";
import { useFormContext, useWatch } from "react-hook-form";

import { FormSelect } from "../../../../../shared";
import type { ContractTemplate } from "../../../../../hooks/query/useOrganization";

type ContractSettingsProps = {
    contractTemplates?: ContractTemplate[];
};

export function ContractSettings({ contractTemplates = [] }: ContractSettingsProps) {
    const { control } = useFormContext();
    const selectedTemplateId = useWatch({ control, name: "ContractTemplateId" });
    const templateOptions = contractTemplates.map((t) => ({
        value: t.Id,
        label: t.Name,
    }));
    const selectedTemplate = contractTemplates.find((t) => t.Id === selectedTemplateId);

    return (
        <Box display="flex" flexDirection="column" gap={1.5} maxWidth={640}>
            <Box mb={0.5}>
                <Typography level="title-md" sx={{ fontWeight: 700 }}>
                    Contract document
                </Typography>
                <Typography level="body-sm" sx={{ color: "text.secondary" }}>
                    PDF layout used when this tenant generates estimate contracts.
                </Typography>
            </Box>

            <FormSelect
                name="ContractTemplateId"
                label="Contract Template"
                helperText="Assigned template for estimate contracts and signing"
                options={templateOptions}
                startDecorator={<FileText size={16} />}
                placeholder="Select a template"
            />
            {selectedTemplate?.Description ? (
                <Typography level="body-xs" sx={{ color: "text.tertiary" }}>
                    {selectedTemplate.Description}
                </Typography>
            ) : null}
        </Box>
    );
}
